import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#F8F9FA] py-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-bold text-[#003366] mb-4">クレカ比較ナビ</h3>
            <p className="text-sm text-gray-600">
              あなたに最適なクレジットカード選びをサポートします。
            </p>
          </div>
          <div>
            <h4 className="font-bold text-[#003366] mb-4">カテゴリ</h4>
            <ul className="space-y-2">
              <li><Link to="/ranking" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">ランキング</Link></li>
              <li><Link to="/comparison" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">カード比較</Link></li>
              <li><Link to="/free" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">年会費無料</Link></li>
              <li><Link to="/highreturn" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">高還元率</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-[#003366] mb-4">人気カード</h4>
            <ul className="space-y-2">
              <li><Link to="/mitsui" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">三井住友カード（NL）</Link></li>
              <li><Link to="/ec-mall-card" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">大手ECモール系カード</Link></li>
              <li><Link to="/ja" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">地域密着型カード</Link></li>
              <li><Link to="/jaccs" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">ジャックス Gold Time</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-[#003366] mb-4">関連リンク</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://www.jabank.org/kouza/" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">
                  提携金融機関口座開設
                </a>
              </li>
              <li>
                <a href="https://www.ad.jacard.cr.mufg.jp/af/?utm_source=affiliate&utm_medium=A8" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-[#00A040] cursor-pointer">
                  カード公式サイト
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 text-center">
          <p className="text-xs text-gray-500 mb-2">
            ※当サイトは各カード会社の公式サイトではありません。最新情報は各公式サイトでご確認ください。
          </p>
          <p className="text-xs text-gray-500">
            © 2024 クレカ比較ナビ All Rights Reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#00A040] cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
